<template>
  <div>
    <ul>
      <li @click="selectSession(session)" class="clearfix" v-for="session in orderBy(nim.sessions, 'lastMsgTime', -1)">
        <div class="img-container">
          <img v-if="session.user && session.user.avatar" :src="session.user.avatar.indexOf('http://pic.joyorders.com')>-1?session.user.avatar:'http://pic.joyorders.com' + session.user.avatar" />
          <img v-if="session.user && !session.user.avatar" src="../../assets/images/avatar@2x.png" />
          <i class="status online" v-if="nim.accountOnlineStates.indexOf(session.to) >= 0"></i>
          <i class="status" v-if="nim.accountOnlineStates.indexOf(session.to) < 0"></i>
          <!--<i class="status unread" v-if="session.lastMsg.isUnreadable"></i>-->
        </div>
        <div class="txt-container">
          <div class="clearfix">
            <div v-if="session.user" class="name">{{session.user.nick}}</div>
            <div v-if="session.lastMsg.isToday" class="date">{{session.lastMsg.time | moment('HH:mm')}}</div>
            <div v-else-if="session.lastMsg.isYestday" class="date">昨天</div>
            <div v-else class="date">{{session.lastMsg.time | moment('YYYY-MM-DD')}}</div>
          </div>
          <div class="msg-text" v-if="session.lastMsg.type == 'text'" v-html="session.lastMsg.text"></div>
          <div class="msg-text" v-if="session.lastMsg.type == 'file'">[文件]</div>
          <div class="msg-text" v-if="session.lastMsg.type == 'image'">[图片]</div>
          <div v-if="session.unread" class="unread">{{session.unread}}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import emojiObj from '../../configs/emoji.js'
import formatTime from '../../services/formatTime.js'
let _ = require('lodash')

export default {
  name: 'ChatSessions',
  props: [],
  components: {
  },
  computed: {
    nim () {
      return this.$store.state.nim
    }
  },
  data () {
    return {
    }
  },
  created () {
    if (this.nim.getUsers) {
      this.getUsers()
    } else {
      // window.location.href = '#/login'
      this.$router.push(
        {
          path: '/login',
        }
      )
    }
  },
  methods: {
    selectSession (session) {
      this.$emit('selectSession', session)
    },
    getUsers () {
      let accounts = []

      if (!this.nim.sessionEnable && this.nim.users.length) {
        this.nim.sessions = []
        _.each(this.nim.users, user => {
          this.nim.sessions.push({
            id: `p2p-${user.account}`,
            lastMsg: {},
            scene: "p2p",
            to: user.account
          })
        })
      }

      _.each(this.nim.sessions, session => {
        accounts.push(session.to)
        formatTime(session)
      })

      this.nim.getUsers({
          accounts: accounts,
          done: (error, users) => {
            console.log(error);
            console.log(users);
            console.log('获取用户资料数组' + (!error?'成功':'失败'), users, this.nim.sessions);
            if (!error) {
              _.each(this.nim.sessions, session => {
                console.log('sessionsessionsession', session);
                let item = session.lastMsg
                if (item.type === 'text') {
                  if (/\[[^\]]+\]/.test(item.text)) {
                    let emojiItems = item.text.match(/\[[^\]]+\]/g)
                    emojiItems.forEach(text => {
                      let emojiCnt = emojiObj.emojiList.emoji
                      if (emojiCnt[text]) {
                        item.text = item.text.replace(text, `<img width="20" style="vertical-align: middle;" class="emoji-small" src="${emojiCnt[text].img}">`)
                      }
                    })
                  }
                }
                _.each(users, user => {
                  if (session.to == user.account) {
                    session.user = user
                    return
                  }
                })
              })
              this.$forceUpdate()
            }
          }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  ul {
    margin-left: 30px;

    li {
      padding: 15px 20px;
      height: 69px;
      border-bottom: 1px solid #EAEAEA;
      padding-bottom: 10px;
      position: relative;
      cursor: pointer;

      & > div {
        float: left;

        &.img-container {
          position: absolute;
          top: 15px;
          left: 0;
          width: 45px;
          height: 45px;
          border-radius: 100%;
          margin-right: 9px;

          img {
            width: 45px;
            height: 45px;
            border-radius: 100%;
          }

          .status {
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 10px;
            background-color: #999999;
            position: absolute;
            right: 0;
            bottom: 0;

            &.online {
              background-color: #4EB400;
            }

            &.unread {
              top: -5px;
              right: -5px;
              background-color: #d23834;
            }
          }
        }

        &.txt-container {
          width: 100%;
          padding-left: 40px;
          padding-top: 7px;
        }
      }

      .name {
        float: left;
        font-size: 14px;
        color: #333;
      }

      .date {
        float: right;
        color: #999999;
        font-size: 10px;
        line-height: 10px;
      }

      .unread {
        float: right;
        color: #999999;
        font-size: 12px;
        line-height: 10px;
        background-color: red;
        color: #fff;
        padding: 3px;
        min-width: 16px;
        text-align: center;
        border-radius: 8px;
        margin-top: 8px;
      }

      .msg-text {
        margin-top: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #666666;
        font-size: 12px;
        text-align: left;
        float: left;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/chat/ChatSessions.vue